// import React from "react";
// import "./paramedical.css";
// import InquiryForm from "../InquiryForm";

// const ParamedicalCareerUSA = () => {
//   return (
//     <div className="career-container">
//       <h1 className="career-title">Paramedical Career in USA</h1>
//       <div className="career-card animate-fade">
//         <h2>Overview</h2>
//         <p>
//           In the USA, paramedics play a vital role in emergency healthcare, 
//           working with hospitals, fire departments, and private ambulance services.
//         </p>
//       </div>

//       <div className="career-card animate-slide">
//         <h2>Education</h2>
//         <p>
//           A high school diploma is required, followed by an EMT program and 
//           Paramedic certification. Many pursue Associate’s or Bachelor’s degrees 
//           in Paramedicine.
//         </p>
//       </div>

//       <div className="career-card animate-fade">
//         <h2>Licensure</h2>
//         <p>
//           Paramedics must pass the <b>National Registry of Emergency Medical Technicians (NREMT)</b> 
//           exam to become certified.
//         </p>
//       </div>

//       <div className="career-img">
//         <img 
//           src="https://th.bing.com/th/id/OIP.r4l-wV-CU0nRADjzhOP9-gHaFz?w=237&h=186&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3" 
//           alt="Paramedical Career USA"
//         />
//       </div>

//       <InquiryForm title="Inquire About USA Programs" />
//     </div>
//   );
// };

// export default ParamedicalCareerUSA;
import React from "react";
import "./paramedical.css";
import InquiryForm from "../InquiryForm";

const ParamedicalCareerUSA = () => {
  return (
    <div className="career-container">
      <h1 className="career-title">Paramedical Career in USA</h1>

      {/* Overview */}
      <div className="career-card animate-fade">
        <h2>Overview</h2>
        <p>
          A paramedical career in the USA is a strong option for international
          candidates, but the pathway depends heavily on licensing, visa
          eligibility, and the specific field you choose. International candidates
          can pursue rewarding roles such as EMT, radiology, and medical laboratory
          technology. Success requires completing U.S. certification exams,
          credential evaluations, and securing employer visa sponsorship.
        </p>
      </div>

      {/* Top Fields in Demand */}
      <div className="career-card animate-slide">
        <h2>Top Paramedical Fields in Demand</h2>
        <ul>
          <li>
            <b>Emergency Medical Services (EMT & Paramedic):</b> Highly sought
            after across major U.S. ambulance providers and hospitals.
          </li>
          <li>
            <b>Radiologic & MRI Technologists:</b> Requires a two-to-four-year
            degree or certification; known for high salary ceilings.
          </li>
          <li>
            <b>Medical Laboratory Technicians (MLT):</b> Vital for diagnostic
            services; requires accredited U.S. testing and certification.
          </li>
          <li>
            <b>Occupational / Physiotherapy Assistants:</b> Fast-growing fields
            offering both clinical practice and high demand.
          </li>
        </ul>
      </div>

      {/* How to Get In */}
      <div className="career-card animate-fade">
        <h2>How to Enter the U.S. System</h2>
        <ul>
          <li>
            <b>Credential Evaluation:</b> Have your international education
            evaluated by recognized agencies like CGFNS or WES to prove
            equivalency to U.S. standards.
          </li>
          <li>
            <b>Certification:</b> Pass the NREMT exam for emergency roles, or
            the ASCP board exam for laboratory roles.
          </li>
          <li>
            <b>Visa Sponsorship:</b> Secure a U.S. job offer supporting
            sponsorship (H-1B or TN visa for Canadian/Mexican citizens). Many
            large ambulance companies offer international onboarding and
            relocation packages.
          </li>
          <li>
            <b>State Licensure:</b> Allied health licenses are managed at the
            state level. Apply for licensure in the specific state where you
            plan to practice.
          </li>
        </ul>
      </div>

      {/* Common Roles */}
      <div className="career-card animate-slide">
        <h2>Common Paramedical / Allied Health Roles</h2>
        <ul>
          <li>EMT (Emergency Medical Technician) / Paramedic</li>
          <li>Medical Laboratory Technician (MLT)</li>
          <li>Radiologic Technologist</li>
          <li>Respiratory Therapist</li>
          <li>Physiotherapy Assistant</li>
          <li>Patient Care / Nursing Assistant</li>
        </ul>
      </div>

      {/* Popular Courses */}
      <div className="career-card animate-fade">
        <h2>Popular Courses</h2>
        <ul>
          <li>
            <b>Associate Degree (2 years)</b> – MLT, Radiology, Respiratory
            Therapy
          </li>
          <li>
            <b>Bachelor's Degree (4 years)</b> – Paramedic Science, Healthcare
            fields
          </li>
          <li>
            <b>Certificate Programs</b> – EMT / CNA
          </li>
        </ul>
      </div>

      {/* Salary Range */}
      <div className="career-card animate-slide">
        <h2>Salary Range in USA</h2>
        <ul>
          <li><b>EMT / Paramedic</b> → $40,000 – $70,000</li>
          <li><b>Radiologic Technologist</b> → $60,000 – $85,000</li>
          <li><b>Medical Lab Technician</b> → $50,000 – $75,000</li>
          <li><b>Respiratory Therapist</b> → $65,000 – $90,000</li>
        </ul>
      </div>

      {/* Licensing Requirements */}
      <div className="career-card animate-fade">
        <h2>Licensing Requirements</h2>
        <p><b>For EMT / Paramedic:</b></p>
        <ol>
          <li>Complete accredited program</li>
          <li>Pass NREMT exam</li>
          <li>Get state license</li>
        </ol>
        <p><b>For Other Paramedical Fields — Certification Bodies:</b></p>
        <ul>
          <li>American Registry of Radiologic Technologists (Radiology)</li>
          <li>American Society for Clinical Pathology (Lab Tech)</li>
        </ul>
      </div>

      {/* High Demand & Visa Friendly */}
      <div className="career-card animate-slide">
        <h2>High-Demand & Visa-Friendly Options</h2>
        <ul>
          <li><b>Nursing</b> – Best option in USA</li>
          <li>Medical Lab Science (MLS)</li>
          <li>Healthcare IT / Health Informatics</li>
          <li>Aged Care / CNA → pathway to Nursing</li>
          <li>Radiology (moderate opportunity)</li>
        </ul>
      </div>

      {/* Image */}


      <InquiryForm title="Inquire About USA Programs" />

        <div className="back-home-wrapper">
  <button className="back-home-btn" onClick={() => window.location.href = "/"}>
    ← Go Back to Home
  </button>
</div>
    </div>
  );
};

export default ParamedicalCareerUSA;